// 

import { UserInfo } from "../services/account/account-rest-interface";
import { hasResilienceReminders, hasSchoolSafety } from "../services/account/account-utils";

export const PARTNER_MACDERMOTT_METHOD = "MacDermott Method"

export function allowMindsetMoments(userInfo: UserInfo) {
    let hasRR = hasResilienceReminders(userInfo)

    if ((userInfo.isTeacher || userInfo.bundleId === "schoolSafetySecurity") && hasRR) {
        return true
    }

    return false
}


export interface IPartnerInfo {
    name: string
    logo: string
    logoSmall: string
}

/**
 * Based on the user info get possible parner info (if any!)
 * @param userInfo 
 * @returns 
 */
export function getPartnerInfo(userInfo: UserInfo): IPartnerInfo| undefined {
    // let hasSSS = hasSchoolSafety(userInfo)
    // let hasRR = hasResilienceReminders(userInfo)

    // if (hasSSS && hasRR) {
    //     return {
    //         name: PARTNER_MACDERMOTT_METHOD,
    //         logo: "/assets/images/macdermott-method-logo.png",
    //         logoSmall: "/assets/images/macdermott-method-logo-small.png"
    //     }
    // }

    return undefined
}
